import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Layout({ children }) {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const appTabs = [
    { path: '/app',              label: 'Dashboard'        },
    { path: '/app/buy-centro',   label: 'Buy Centro'       },
    { path: '/app/create',       label: 'Create Agreement' },
    { path: '/app/agreements',   label: 'Agreements'       },
  ];

  return (
    <div className="page-shell">
      <nav className={`nav-bar${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-inner">
          <button className="nav-brand" onClick={() => navigate('/')}>
            Stanford <span>Centro</span>
          </button>

          {isAuthenticated && (
            <ul className="nav-links">
              {appTabs.map((tab) => (
                <li key={tab.path}>
                  <button
                    className={`nav-link${location.pathname === tab.path ? ' active' : ''}`}
                    onClick={() => navigate(tab.path)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          )}

          <div className="nav-right">
            {isAuthenticated ? (
              <>
                <span className="nav-user">
                  <strong>{user.userId}</strong>
                </span>
                <button className="nav-btn ghost" onClick={handleLogout}>
                  Log Out
                </button>
              </>
            ) : (
              <button
                className="nav-btn"
                onClick={() => navigate('/login')}
              >
                Log In
              </button>
            )}
          </div>
        </div>
      </nav>

      <div style={{ flex: 1 }}>
        {children}
      </div>

      <footer className="page-footer">
        Stanford Centro · Built on Hyperledger Fabric
      </footer>
    </div>
  );
}

export default Layout;
